﻿import type { CrosswindResult, WindData } from './types';

function toRad(deg: number): number {
    return (deg * Math.PI) / 180;
}

export function calculateCrosswindRaw(
    runwayHeading: number,
    wind: WindData,
    gustFactor: number = 1.0
): CrosswindResult {
    const effectiveSpeed = wind.gust != null && wind.gust > wind.speed
        ? wind.speed + gustFactor * (wind.gust - wind.speed)
        : wind.speed;
    const angleDiff = toRad(wind.direction - runwayHeading);
    return {
        headwind:  effectiveSpeed * Math.cos(angleDiff),
        crosswind: effectiveSpeed * Math.sin(angleDiff)
    };
}

export function roundCrosswind(result: CrosswindResult): CrosswindResult {
    return {
        headwind:  Math.round(result.headwind * 10) / 10,
        crosswind: Math.round(result.crosswind * 10) / 10
    };
}

export function calculateCrosswind(
    runwayHeading: number,
    wind: WindData,
    gustFactor: number = 1.0
): CrosswindResult {
    return roundCrosswind(calculateCrosswindRaw(runwayHeading, wind, gustFactor));
}

